import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { DealersDashboardQueryKeys } from "modules/DealersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { TyreTeamCredential } from "models";

export const useDeleteTyreTeamCredentialMutation = () =>
  useTypedMutation<TyreTeamCredential, void>({
    mutationFn: async ({ id }) => {
      await ApiInstance.post("/credentials/delete", { id }, ENV.tyreTeamBaseURL);
    },
    onSuccess: deletedCredential => {
      const credentials = typedQueryClient.getQueryData(DealersDashboardQueryKeys.tyreTeamCredentials(deletedCredential.dealer_location_id));
      if (!credentials?.length) return;

      const credentialIdx = credentials.findIndex(({ id }) => id === deletedCredential.id);
      if (credentialIdx === -1) return;

      typedQueryClient.setQueryData(DealersDashboardQueryKeys.tyreTeamCredentials(deletedCredential.dealer_location_id), credentials.toSpliced(credentialIdx, 1));
    }
  });
